import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { Annotation, Resolution } from './types'

export function useGetByEngagementId(id?: string) {
  return useQuery({
    queryKey: ['engagement-resolutions', id],
    queryFn: async () => {
      const { data } = await apiClient.get<Resolution[]>(`int/v2/resolution`, {
        params: {
          engagement_id: id,
        },
      })

      return data
    },
    enabled: Boolean(id),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    select: (resolutions) => {
      if (!resolutions) return undefined

      const auditedResolutions = resolutions.filter((resolution) => Boolean(resolution.ground_truth))
      const responseResolutions = resolutions.filter((resolution) => !resolution.ground_truth)

      const auditedAnnotations: Annotation[] = []
      const responseAnnotations: Annotation[] = []

      if (auditedResolutions.length >= 1)
        auditedResolutions[0].annotations?.forEach((annotation) => auditedAnnotations.push(annotation))

      responseResolutions.forEach((resolution) =>
        resolution?.annotations?.forEach(
          (annotation) => Boolean(annotation.original_annotation_id) && responseAnnotations.push(annotation)
        )
      )

      return {
        resolutions,
        annotations: { audited: auditedAnnotations, response: responseAnnotations },
        wasAudited: auditedResolutions.length > 0,
      }
    },
  })
}
